import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const BOOKS = [
  {
    title: "When the Shadows Spoke",
    author: "Sweta Singh",
    img: "/book2.jpeg",
    tagline: "Every life has a past. Some are stolen. Some are rewritten. Some are never meant to be remembered.",
    description: (
      <>
        <span className="block mb-3 text-[#565449]">
          When Crime Branch officer Arjun Mehra investigates missing records and altered histories, he stumbles into a world where even memories can be rewritten. His uneasy alliance with Reema—a woman weighted by silence and secrets—draws them deeper into a mystery where truth is perilous and trust is rare.
        </span>
        <span className="block mb-3 text-[#565449]">
          As hidden lives demand to be seen, Arjun realizes some secrets are kept because they're dangerous, and some because they were never meant to survive. In this quietly unsettling thriller, erased pasts and hidden power haunt every shadow.
        </span>
        <span className="block text-[#867e68] italic">
          Once the shadows begin to speak, there is no turning back.
        </span>
      </>
    ),
    amazonLink: "https://www.amazon.in/Shadows-Spoke-Remember-Truth-Forgets/dp/B0GD197W8T?ref_=ast_author_dp&th=1&psc=1",
  },
  {
    title: "When the Rain Paused",
    author: "Sweta Singh",
    img: "/book1.jpeg",
    tagline: "Some love stories arrive like storms. Others begin in stillness — in a moment so quiet it changes everything.",
    description: (
      <>
        <span className="block mb-3 text-[#565449]">
          Set in rain-washed Mumbai, this deeply moving story follows Aanya and Rivan—two souls brought together by fate and bound by something more powerful than coincidence.
        </span>
        <span className="block mb-3 text-[#565449]">
          What starts as a hesitant encounter unfolds into a love that is intense, tender, and quietly transformative. But secrets linger and the past refuses to stay buried. As a dark turn of fate threatens everything, Aanya and Rivan must discover if their love can survive—when everything else falls apart.
        </span>
        <span className="block text-[#867e68] italic">
          Some moments feel like rain. Some feel like storms. And some… feel like everything stops, just long enough for love to begin.
        </span>
      </>
    ),
    amazonLink: "https://www.amazon.in/When-Rain-Paused-Story-Shadow/dp/B0FJMHNQ3L",
  },
 
];

const HeroSection = () => {
  return (
    <section className="relative pt-36 md:pt-24 pb-10 bg-[#F1E8D8]">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        className="h-[70vh]"
      >
        {BOOKS.map((book, i) => (
          <SwiperSlide key={book.title}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center h-full px-6 lg:px-20 ">
              <div className="space-y-6 max-w-2xl">
                <p className="tracking-widest text-sm text-[#565449] mb-2">NEW RELEASE</p>
                <h1 className="text-3xl lg:text-5xl font-serif text-[#11120D]">{book.title}</h1>
                <p className="text-[#867e68] text-base font-medium mb-1">By {book.author}</p>
                <p className="text-[#565449] text-base italic mb-3">{book.tagline}</p>
                <div className="text-[15px] leading-relaxed">
                  {book.description}
                </div>
                {/* Add Buy Now button for "When the Shadows Spoke" */}

                  <a
                    href={book.amazonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-[#FF9900] hover:bg-[#e68300] transition text-white font-semibold px-7 py-3 rounded mt-2 tracking-widest shadow-md"
                  >
                    Buy Now on Amazon
                  </a>

                {/* <button className="bg-[#4b3929] text-white font-semibold px-6 py-2 rounded mt-2 tracking-widest">SEE DETAILS</button> */}
              </div>
              <div className="flex justify-center">
                <img
                  src={book.img}
                  alt={book.title + " cover"}
                  className="shadow-2xl max-h-[420px] w-auto rounded-md bg-[#e7dbcb] object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default HeroSection
